import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';

import DeductionsReportErrors, {
  getDeductionsReportErrorsHeading,
} from 'app/components/DeductionReports/DeductionsReportErrors';

import { DeductionsReportRow } from 'app/components/UI/Table/Table.types';

interface DeductionsReportErrorsModalProps {
  report?: DeductionsReportRow;
  onClose: () => void;
}

/** Shows why a company deductions report failed, or its warnings, without leaving the list of reports. */
function DeductionsReportErrorsModal({
  report = undefined,
  onClose,
}: DeductionsReportErrorsModalProps) {
  return (
    <Modal isOpen={!!report} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent data-testid="deductions-report-errors-modal">
        <ModalHeader>{getDeductionsReportErrorsHeading(report?.status)}</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb="24px">
          <DeductionsReportErrors
            deductionsReportId={report?.id}
            status={report?.status}
            showHeading={false}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default DeductionsReportErrorsModal;
